import { action, asyncAction } from 'now-frontend-shared/utils/actions';

// async actions
export const getPropertiesMarkers = asyncAction('map/GET_PROPERTIES_MARKERS');

// sync actions
export const clearState = action('map/CLEAR_STATE');
